import React from 'react';
import Icon from '../../../components/AppIcon';

const DocumentTypeSelector = ({ selectedType, onTypeChange }) => {
  const documentTypes = [
    {
      id: 'national-id',
      value: 'national-id',
      label: 'Carte d\'identité nationale',
      description: 'Document d\'identité français officiel',
      icon: 'CreditCard'
    },
    {
      id: 'passport',
      value: 'passport',
      label: 'Passeport',
      description: 'Passeport français ou européen',
      icon: 'BookOpen'
    }
  ];

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-text-primary font-inter mb-4">
        Type de document
      </h3>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {documentTypes.map((type) => (
          <label
            key={type.id}
            className={`relative flex items-center p-4 rounded-lg border-2 cursor-pointer transition-smooth hover:border-primary-200 ${
              selectedType === type.value
                ? 'border-primary bg-primary-50' :'border-border bg-surface hover:bg-secondary-50'
            }`}
          >
            <input
              type="radio"
              name="documentType"
              value={type.value}
              checked={selectedType === type.value}
              onChange={(e) => onTypeChange(e.target.value)}
              className="sr-only"
            />
            
            <div className="flex items-center space-x-3 w-full">
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center ${
                selectedType === type.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-secondary-100 text-text-secondary'
              }`}>
                <Icon name={type.icon} size={20} />
              </div>
              
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between">
                  <h4 className={`text-sm font-medium font-inter ${
                    selectedType === type.value ? 'text-primary' : 'text-text-primary'
                  }`}>
                    {type.label}
                  </h4>
                  
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
                    selectedType === type.value
                      ? 'border-primary bg-primary' :'border-border bg-surface'
                  }`}>
                    {selectedType === type.value && (
                      <div className="w-2 h-2 rounded-full bg-primary-foreground" />
                    )}
                  </div>
                </div>
                
                <p className="text-xs text-text-secondary font-inter mt-1">
                  {type.description}
                </p>
              </div>
            </div>
          </label>
        ))}
      </div>
    </div>
  );
};

export default DocumentTypeSelector;